import { graphql, useStaticQuery } from 'gatsby';
import * as React from 'react'; // tslint:disable-line
import { TrendsProvider as Provider } from '@shapeable/ui';
import { sortBy } from 'lodash';
import { shapeableProviderValue } from '@shapeable/gatsby-theme-shapeable-web/src/components/providers/provider-value';

const TRENDS_QUERY = graphql`
query NodeAllTrendsQuery {
  allShapeableCollectionRecord(filter: { collectionKey: { eq: "Trends" } }) {
    nodes {
      data
    }
  }
}
`;

export const TrendsProvider: React.FC<any> = ({ children }) => {
  return (
    <Provider value={sortBy(shapeableProviderValue(useStaticQuery(TRENDS_QUERY), 'items'), 'outlineNumber')}>
      {children}
    </Provider>
  );
};
